module.exports = __webpack_public_path__ + "img/te-map.29f03df0.svg";